module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"helpSite":"Help site","onlineSupport":"Blog"},"ja":{"helpSite":"ヘルプサイト","onlineSupport":"活用ブログ"},"zh-hant":{"helpSite":"幫助網站","onlineSupport":"Blog"},"zh-hans":{"helpSite":"帮助网站","onlineSupport":"Blog"}}')
  delete Component.options._Ctor
}
